module.exports = __webpack_public_path__ + "static/img/prod-xy.da081f6c.jpg";